'use strict';

import React from 'react';

import Menu from './Menu.js'
import ContactForm from './ContactForm.js'

class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="header-component">
        <div className="header-content">
          {/* <a href="#inicio"><img className="header-logo" alt="Toc To Me" src='/static/images/toctome-logo-cinza.svg'></img></a> */}
          <a href="#inicio"><img className="header-logo hidden" id="header-logo" alt="Toc To Me" src='/static/images/toctome.svg'></img></a>
          <ContactForm />
          <Menu />
        </div>
      </div>
    );
  }
}

Header.displayName = 'Header';

// Uncomment properties you need
// Header.propTypes = {};
// Header.defaultProps = {};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js